import { Box, Button, Menu, MenuButton, MenuList } from '@chakra-ui/react';
import { Icon, IconMap } from '@common/components/Icon';
import { FontFamily } from '@common/theming/Fonts';
import React, { PropsWithChildren, useRef, useState } from 'react';

type NavbarSubmenuProps = {
  label: string;
  icon: keyof typeof IconMap;
};

export const NavbarSubmenu: React.FC<PropsWithChildren<NavbarSubmenuProps>> = ({ icon, label, children }) => {
  const timerRef = useRef<number>();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const childLength = React.Children.count(children);
  const _children = React.Children.map(children, (child, i) => {
    // automatically add divider to all children except the last one
    if (i < childLength - 1) {
      return React.cloneElement(child as React.ReactElement, {
        borderBottom: '1px solid rgba(0,0,0,0.1)',
      });
    } else {
      return child;
    }
  });

  const onButtonMouseEnter = () => {
    setIsMenuOpen(true);
  };

  const onButtonMouseLeave = () => {
    timerRef.current = window.setTimeout(() => {
      setIsMenuOpen(false);
    }, 150);
  };

  const onMenuMouseEnter = () => {
    clearTimeout(timerRef.current);
    timerRef.current = undefined;
    setIsMenuOpen(true);
  };

  const onMenuMouseLeave = () => {
    setIsMenuOpen(false);
  };

  const isCurrentRoute = (() => {
    return (
      (label === 'Invest' && window.location.pathname.startsWith('/checkout')) ||
      window.location.pathname.startsWith('/properties')
    );
  })();

  return (
    <Menu isOpen={isMenuOpen}>
      <MenuButton
        as={Box}
        p="2px"
        background={isCurrentRoute ? 'linear-gradient(to bottom, #63AAFF, #C7E0FF, #C4A8FF)' : 'none'}
        borderRadius={'8px'}
        cursor="pointer"
        onMouseEnter={onButtonMouseEnter}
        onMouseLeave={onButtonMouseLeave}
        _hover={{ background: 'linear-gradient(to bottom, #63AAFF, #C7E0FF, #C4A8FF)' }}>
        <Button
          display={'flex'}
          borderRadius={'6px'}
          backgroundColor={'white'}
          alignItems="center"
          leftIcon={<Icon icon={icon} boxSize="16px" variant="regular" />}
          colorScheme="black"
          fontFamily={FontFamily.HELVETICA_NOW_BOLD}
          fontWeight="normal"
          lineHeight={'16px'}
          variant="ghost">
          {label}
          <Icon ml="8px" icon={'chevron-down'} boxSize="10px" variant="solid" />
        </Button>
      </MenuButton>
      <MenuList
        onMouseEnter={onMenuMouseEnter}
        onMouseLeave={onMenuMouseLeave}
        style={{ borderColor: 'rgb(0,0,0,0.1)', padding: 0 }}>
        {_children}
      </MenuList>
    </Menu>
  );
};
